import { render, staticRenderFns } from "./SecondaryNavbar.vue?vue&type=template&id=764ed80a"
import script from "./SecondaryNavbar.vue?vue&type=script&lang=js"
export * from "./SecondaryNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports